<script setup lang="ts">
  import Box from '@leaflink/stash/Box.vue';
  import { I18nT } from 'vue-i18n';

  import { i18n } from '@/plugins';

  type FeatureCardProps = {
    image: string;
    keypath: string;
    keywords?: string[];
  };

  const props = defineProps<FeatureCardProps>();
</script>

<template>
  <div class="tw-max-w-[368px]">
    <Box
      class="tw-aspect-[8/5] tw-bg-center"
      :style="{
        // The class tw-bg-[url(...)] does not work with dynamic images
        backgroundImage: `url(${props.image})`,
      }"
    />

    <I18nT :keypath="props.keypath" scope="global" tag="p" class="tw-mt-6 tw-text-xl">
      <strong v-for="(word, index) in props.keywords" :key="`${word}-${index}`" class="tw-text-ice-900">
        {{ i18n.t(word) }}
      </strong>
    </I18nT>
  </div>
</template>
